module.exports = __webpack_public_path__ + "media/2x/R-30198750.png";